var AssetDirectory = {
	"preloader": [
		"assets/font/preloader/exo-bold.ttf",
		"assets/font/preloader/exo-medium.ttf",
		"assets/font/preloader/proximanova-black.ttf",
		"assets/images/preloader/loader/gfx_bg.png",
		"assets/images/preloader/loader/gfx_loading.png",
		"assets/images/preloader/loader/gizmoloading.json",
		"assets/images/preloader/loader/gizmoloading_ske.json",
		"assets/images/preloader/loader/gizmoloading_tex.json",
		"assets/images/preloader/loader/gizmoloading_tex.png",
		"assets/sounds/preloader/loader/bgm/game_bgm.ogg",
		"assets/sounds/preloader/loader/sfx/button_sfx.ogg",
		"assets/sounds/preloader/loader/sfx/score_points.ogg",
		"assets/sounds/preloader/loader/sfx/star_gain.ogg",
		"assets/strings/preloader/strings.json"
	],
	"game": [
		"assets/images/external/game/bg_behindwater.png",
		"assets/images/external/game/bg_clouds.png",
		"assets/images/external/game/bg_dove.png",
		"assets/images/external/game/bg_sky.png",
		"assets/images/external/game/birds/birds_anim_ske.json",
		"assets/images/external/game/birds/birds_anim_tex.json",
		"assets/images/external/game/birds/birds_anim_tex.png",
		"assets/images/external/game/bump/fx_bump_ske.json",
		"assets/images/external/game/bump/fx_bump_tex.json",
		"assets/images/external/game/bump/fx_bump_tex.png",
		"assets/images/external/game/dove/dove_anim_ske.json",
		"assets/images/external/game/dove/dove_anim_tex.json",
		"assets/images/external/game/dove/dove_anim_tex.png",
		"assets/images/external/game/dove_lightning.png",
		"assets/images/external/game/dove_prop.png",
		"assets/images/external/game/flood/fx_flood_ske.json",
		"assets/images/external/game/flood/fx_flood_tex.json",
		"assets/images/external/game/flood/fx_flood_tex.png",
		"assets/images/external/game/obstacle/obs_branchandcloth_ske.json",
		"assets/images/external/game/obstacle/obs_branchandcloth_tex.json",
		"assets/images/external/game/obstacle/obs_branchandcloth_tex.png",
		"assets/images/external/game/obstacle.png",
		"assets/images/external/game/obstacle_tree01.png",
		"assets/images/external/game/obstacle_tree02.png",
		"assets/images/external/game/splash/fx_splash_ske.json",
		"assets/images/external/game/splash/fx_splash_tex.json",
		"assets/images/external/game/splash/fx_splash_tex.png",
		"assets/sounds/external/game/obstacle_hit.ogg",
		"assets/sounds/external/game/spawn_brownbird.ogg",
		"assets/sounds/external/game/spawn_crow.ogg",
		"assets/sounds/external/game/spawn_eagle.ogg",
		"assets/sounds/external/game/wing_flap.ogg"
	],
	"title": [
		"assets/images/external/title/bg_logo_dove.png",
		"assets/images/external/title/dove.png",
		"assets/images/external/title/logo_dove.png"
	],
	"ui": [
		"assets/images/external/ui/btn_audio1.png",
		"assets/images/external/ui/btn_audio2.png",
		"assets/images/external/ui/btn_audio3.png",
		"assets/images/external/ui/btn_audio4.png",
		"assets/images/external/ui/btn_exit.png",
		"assets/images/external/ui/btn_exit2.png",
		"assets/images/external/ui/btn_pause.png",
		"assets/images/external/ui/btn_pause2.png",
		"assets/images/external/ui/btn_play.png",
		"assets/images/external/ui/btn_play2.png",
		"assets/images/external/ui/btn_prevnext.png",
		"assets/images/external/ui/btn_prevnext2.png",
		"assets/images/external/ui/btn_replay.png",
		"assets/images/external/ui/btn_replay2.png",
		"assets/images/external/ui/btn_return.png",
		"assets/images/external/ui/btn_return2.png",
		"assets/images/external/ui/check-button1.png",
		"assets/images/external/ui/check-button2.png",
		"assets/images/external/ui/gfx_container.png",
		"assets/images/external/ui/gfx_container_white.png",
		"assets/images/external/ui/gfx_explode.png",
		"assets/images/external/ui/gfx_flare_long.png",
		"assets/images/external/ui/gfx_flare_star.png",
		"assets/images/external/ui/gfx_loading_bar_con.png",
		"assets/images/external/ui/gfx_pop.png",
		"assets/images/external/ui/gfx_pop2.png",
		"assets/images/external/ui/gfx_star0.png",
		"assets/images/external/ui/gfx_star1.png",
		"assets/images/external/ui/gfx_starbg.png",
		"assets/images/external/ui/htp_dove1.png",
		"assets/images/external/ui/htp_dove2.png",
		"assets/images/external/ui/htp_dove3.png",
		"assets/images/external/ui/htp_dove4.png",
		"assets/images/external/ui/x-button1.png",
		"assets/images/external/ui/x-button2.png"
	]
};